export const DeactivateReasonEnum = [
  { text: 'Deact After Expiration', value: 'DEACT_AFTER_EXPIRATION' },
  { text: 'Deact After Blocking', value: 'DEACT_AFTER_BLOCKING' },
  { text: 'Deact Ctrt Closing', value: 'DEACT_CTRT_CLOSING' },
  { text: 'Deact Ordererror', value: 'DEACT_ORDERERROR' },
  { text: 'Deact Activationexpired', value: 'DEACT_ACTIVATIONEXPIRED' },
  { text: 'Deact Refunded', value: 'DEACT_REFUNDED' },
  { text: 'Deact Malfunctionning', value: 'DEACT_MALFUNCTIONNING' },
  { text: 'Deact Visualchange', value: 'DEACT_VISUALCHANGE' },
  { text: 'Deact Other', value: 'DEACT_OTHER' }
]
